import React, { useState, useEffect } from "react";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import { Row, Container, Col, Image } from "react-bootstrap";
import "../components/principios.css";
import FlipCard from "../components/FlipCard";
import Timeline from "../components/Timeline";
import SocialBar from "../components/SocialBar";
import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';

const API_URL = "https://facach.coop.hn/api";

function Principios() {
  const { settings } = useSiteSettings();
  const bannerSrc = settings.banner_image
    ? `https://facach.coop.hn${settings.banner_image}`
    : fallbackBanner;

  const [about, setAbout] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/about-facach`)
      .then(r => r.json())
      .then(json => { if (json.ok) setAbout(json.data); })
      .catch(err => console.error("Error cargando about:", err.message));
  }, []);

  const principios = [
    { title: "Membresía Abierta y Voluntaria",                        description: "Las cooperativas son organizaciones voluntarias, abiertas a todas las personas." },
    { title: "Control Democrático de las Cooperativas Afiliadas",     description: "Las cooperativas son gestionadas democráticamente por sus miembros." },
    { title: "Participación Económica de las Cooperativas Afiliadas", description: "Los miembros contribuyen equitativamente al capital de la cooperativa." },
    { title: "Autonomía e Independencia",                             description: "Las cooperativas son autónomas y controladas por sus miembros." },
    { title: "Educación, Formación e Información",                    description: "Las cooperativas promueven la educación y formación de sus miembros." },
    { title: "Cooperación entre Cooperativas",                        description: "Las cooperativas trabajan juntas para fortalecer el movimiento." },
    { title: "Compromiso por la Comunidad",                           description: "Las cooperativas trabajan por el desarrollo sostenible de sus comunidades." },
  ];

  return (
    <>
      <NavbarFacach />

      {/* Banner */}
      <div className="banner-wrapper">
        <Image src={bannerSrc} alt="Principios FACACH" fluid className="banner-image" />
        <div className="banner-overlay">
          <h1 className="banner-title">NUESTROS PRINCIPIOS</h1>
        </div>
      </div>

      {/* Misión y Visión */}
      <Container className="principios-container">
        <div style={{ position: "relative", overflow: "hidden" }}>
          <Container style={{ position: "relative", zIndex: 1 }}>
            <Row className="justify-content-center g-4">

              {/* Misión */}
              <Col md={5}>
                <div style={{
                  background: "linear-gradient(135deg, #252a58 0%, #3a4280 100%)",
                  backdropFilter: "blur(10px)",
                  borderRadius: 20, padding: "36px 32px",
                  border: "1px solid rgba(255,255,255,0.15)",
                  height: "100%", transition: "transform 0.2s, box-shadow 0.2s",
                }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "0 20px 48px rgba(0,0,0,0.25)"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                    <div style={{ width: 4, height: 28, borderRadius: 2, background: "linear-gradient(180deg, #f9c31f, #f47920)" }} />
                    <h3 style={{ color: "#fff", fontWeight: 900, fontSize: 22, margin: 0, letterSpacing: 0.5 }}>MISIÓN</h3>
                  </div>
                  <p style={{ color: "rgba(255,255,255,0.88)", fontSize: 15, lineHeight: 1.7, margin: 0 }}>
                    Somos la Federación de Cooperativas de Ahorro y Crédito de Honduras, que integra y
                    representa a sus afiliadas contribuyendo a su desarrollo sostenible y competitivo,
                    a través de la prestación de servicios financieros, técnicos y educativos, a fin de
                    promover el fortalecimiento de la economía social.
                  </p>
                </div>
              </Col>

              {/* Visión */}
              <Col md={5}>
                <div style={{
                  background: "linear-gradient(135deg, #252a58 0%, #3a4280 100%)",
                  backdropFilter: "blur(10px)",
                  borderRadius: 20, padding: "36px 32px",
                  border: "1px solid rgba(255,255,255,0.15)",
                  height: "100%", transition: "transform 0.2s, box-shadow 0.2s",
                }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "0 20px 48px rgba(0,0,0,0.25)"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                    <div style={{ width: 4, height: 28, borderRadius: 2, background: "linear-gradient(180deg, #f9c31f, #f47920)" }} />
                    <h3 style={{ color: "#fff", fontWeight: 900, fontSize: 22, margin: 0, letterSpacing: 0.5 }}>VISIÓN</h3>
                  </div>
                  <p style={{ color: "rgba(255,255,255,0.88)", fontSize: 15, lineHeight: 1.7, margin: 0 }}>
                    Ser la Federación de ahorro y crédito líder en Latinoamérica, reconocida por su
                    solidez financiera, innovación tecnológica y compromiso con la sostenibilidad ambiental.
                    Nuestro equipo altamente calificado y comprometido impulsa el fortalecimiento continuo
                    de nuestras cooperativas afiliadas.
                  </p>
                </div>
              </Col>

            </Row>
          </Container>
        </div>
      </Container>

      {/* Principios Cooperativistas */}
      <section className="principios-section">
        <h2 className="section-title">PRINCIPIOS COOPERATIVISTAS</h2>
        <div className="cards-grid">
          {principios.map((p, index) => (
            <FlipCard key={index} title={p.title} description={p.description} />
          ))}
        </div>
      </section>

      {/* Somos FACACH */}
      {about && (
        <div style={{
          background: "linear-gradient(135deg, #252a58 0%, #3a4280 100%)",
          padding: "72px 24px",
          position: "relative",
          overflow: "hidden",
        }}>
          {/* Decoraciones */}
          <div style={{ position: "absolute", top: -80, right: -80, width: 350, height: 350, borderRadius: "50%", background: "rgba(255,255,255,0.04)" }} />
          <div style={{ position: "absolute", bottom: -100, left: -60, width: 400, height: 400, borderRadius: "50%", background: "rgba(255,255,255,0.03)" }} />

          <Container style={{ position: "relative", zIndex: 1 }}>

            {/* Título */}
            <div style={{ textAlign: "center", marginBottom: 48 }}>
              <div style={{
                display: "inline-block",
                background: "linear-gradient(135deg, #f9c31f, #f47920)",
                color: "#1a2a45", fontSize: 12, fontWeight: 900,
                padding: "5px 20px", borderRadius: 20, letterSpacing: 1, marginBottom: 16,
              }}>NUESTRA HISTORIA</div>
              <h2 style={{
                color: "#fff", fontWeight: 900,
                fontSize: "clamp(1.8rem, 3vw, 2.6rem)",
                margin: 0, letterSpacing: 0.5,
                textShadow: "0 2px 12px rgba(0,0,0,0.2)",
              }}>{about.title}</h2>
            </div>

            <Row className="align-items-center g-5">

              {/* Imagen */}
              {about.image_url && (
                <Col md={5}>
                  <div style={{
                    borderRadius: 20, overflow: "hidden",
                    boxShadow: "0 20px 48px rgba(0,0,0,0.3)",
                    border: "2px solid rgba(255,255,255,0.15)",
                  }}>
                    <img
                      src={about.image_url}
                      alt="Somos FACACH"
                      style={{ width: "100%", height: 320, objectFit: "cover", display: "block" }}
                    />
                  </div>
                </Col>
              )}

              {/* Texto + Stats */}
              <Col md={about.image_url ? 7 : 12}>
                <div
                  style={{ color: "rgba(255,255,255,0.88)", fontSize: 15, lineHeight: 1.8 }}
                  dangerouslySetInnerHTML={{ __html: about.content_html }}
                />

                {/* Estadísticas */}
                {[1, 2, 3, 4].some(n => about[`stat_${n}_value`]) && (
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
                    gap: 16, marginTop: 36,
                  }}>
                    {[1, 2, 3, 4].map(n => (
                      about[`stat_${n}_value`] ? (
                        <div key={n} style={{
                          background: "rgba(255,255,255,0.08)",
                          border: "1px solid rgba(255,255,255,0.15)",
                          borderRadius: 14, padding: "18px 16px", textAlign: "center",
                          backdropFilter: "blur(8px)",
                        }}>
                          <div style={{
                            fontSize: "clamp(1.4rem, 2.5vw, 2rem)",
                            fontWeight: 900, color: "#f9c31f",
                            lineHeight: 1, marginBottom: 6,
                          }}>{about[`stat_${n}_value`]}</div>
                          <div style={{
                            fontSize: 12, color: "rgba(255,255,255,0.75)",
                            fontWeight: 600, lineHeight: 1.3,
                          }}>{about[`stat_${n}_label`]}</div>
                        </div>
                      ) : null
                    ))}
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      )}

      {/* Línea de tiempo */}
      <Timeline />

      <SocialBar position="right" top="35%" size={42} rounded={true} />
      <FooterFacach />
    </>
  );
}

export default Principios;